import { createSlice } from '@reduxjs/toolkit';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: true,
    kpiSubmenuCollapsed: true, 
    simSubmenuCollapsed: true,
    resellerSubmenuCollapsed: true,
    appFeaturesSubmenuCollapsed: true, // Olav

  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    toggleKpiSubmenu: (state) => {
      state.kpiSubmenuCollapsed = !state.kpiSubmenuCollapsed;
    },
    toggleSimSubmenu: (state) => {
      state.simSubmenuCollapsed = !state.simSubmenuCollapsed;
    },
    toggleResellerSubMenu: (state) => {
      state.resellerSubmenuCollapsed = !state.resellerSubmenuCollapsed;
    },
    toggleAppFeaturesSubmenu: (state) => { // Olav
      state.appFeaturesSubmenuCollapsed = !state.appFeaturesSubmenuCollapsed;
    },
  },
});

export const { toggleSidebar, toggleKpiSubmenu, toggleSimSubmenu, toggleResellerSubMenu , toggleAppFeaturesSubmenu} = uiSlice.actions;

export default uiSlice.reducer;
